module.exports = __webpack_public_path__ + "static/media/case.b0137ece.png";